import React from 'react';
import {
    FaBolt,
    FaCheckCircle,
    FaShieldAlt,
    FaClock,
    FaPhone,
    FaSync
} from 'react-icons/fa';
import './WhyChoose.css';

const WhyChoose = () => {
    const reasons = [
        {
            icon: <FaBolt />,
            title: 'Quick & Easy',
            description: 'Get connected with our experts and select services as per your requirement with just a phone call.'
        },
        {
            icon: <FaCheckCircle />,
            title: 'Background Verified',
            description: 'Your safety is our first priority. We do thorough background checks of every profile.'
        },
        {
            icon: <FaShieldAlt />,
            title: 'Safe and Reliable',
            description: 'We provide safe and reliable manpower for your household and healthcare needs.'
        },
        {
            icon: <FaClock />,
            title: 'Punctual & Trustworthy',
            description: 'Our staff is professionally trained to be punctual and trustworthy in all situations.'
        },
        {
            icon: <FaPhone />,
            title: 'Hassle-Free Booking',
            description: 'Get your service with just a single phone call. No complicated procedures.'
        },
        {
            icon: <FaSync />,
            title: 'Replacement Service',
            description: 'We provide replacement services if the person leaves the job for any reason.'
        }
    ];

    return (
        <section className="why-choose section" id="why-choose">
            <div className="container">
                <div className="section-header text-center">
                    <span className="section-tag">Why Choose Us</span>
                    <h2 className="section-title">
                        What Makes Us <span className="text-gradient">Different</span>
                    </h2>
                    <p className="section-description">
                        We are committed to providing exceptional service with care, professionalism, and reliability
                    </p>
                </div>

                <div className="reasons-grid">
                    {reasons.map((reason, index) => (
                        <div className="reason-card" key={index}>
                            <div className="reason-icon-wrapper">
                                <div className="reason-icon">{reason.icon}</div>
                            </div>
                            <h3 className="reason-title">{reason.title}</h3>
                            <p className="reason-description">{reason.description}</p>
                        </div>
                    ))}
                </div>

                <div className="why-choose-footer">
                    <p>Our mission is to give maximum care to people who are in need of it in this modern and fast-moving society.</p>
                </div>
            </div>
        </section>
    );
};

export default WhyChoose;